import md5 from 'md5';

const isNullObject = obj => {
    if (typeof obj !== 'object') return console.error('请传入对象');

    return Object.keys(obj).length > 0;
};

const addZero = num => {
    if (typeof num !== 'number') return console.error('传入的不是数字类型');

    return num < 10 ? `0${num}` : num;
};

/**
 * 生成文章skey值
 **/
export const getSkey = (title, pcUrl) => {
    const str = `Ifeng888${encodeURI(title)}${encodeURI(pcUrl)}`;
    const skey = md5(str);

    return skey.substr(2, 6).toLowerCase();
};

/**
 * @paramas time 时间的时间戳
 * return YYYY-MM-DDTHH:mm:ss
 **/
const formatTime = time => {
    const t = Number(time);
    const date = new Date(t);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const f = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${addZero(m)}-${addZero(d)} ${addZero(h)}:${addZero(f)}:${addZero(s)}`;
};

/**
 * @paramas time 时间的时间戳
 * return {
 *  y, 年
 *  m,
 *  d,
 *  h,
 *  f,
 *  s
 * }
 **/
const formatTimeObj = time => {
    const t = Number(time);
    const date = new Date(t);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const f = date.getMinutes();
    const s = date.getSeconds();

    return {
        y,
        m,
        d,
        h,
        f,
        s,
    };
};
/**
 * @paramas time 时间的时间戳
 * return 年差
 **/
const getAgeStep = time => {
    const year = formatTimeObj(time).y;
    const currentYear = formatTimeObj(+new Date()).y;
    const age = currentYear - year;

    return age;
};

/**
 * @paramas time 时间的时间戳
 * return 月差
 **/
const getMonthStep = time => {
    const month = formatTimeObj(time).m;
    const currentmonth = formatTimeObj(+new Date()).m;
    const monthStep = currentmonth - month;

    return monthStep;
};

/**
 * @paramas time 时间的时间戳
 * return 多少天前或者多少小时前
 **/
const dayBefore = time => {
    const reg = /^\d+$/;
    const isTimeStamp = reg.test(time);
    const currentTime = +new Date();
    const addTime = isTimeStamp ? time * 1000 : +new Date(time);
    let result = '';

    // 先判断年
    const yearStep = getAgeStep(addTime);

    // 判断月差
    const monthStep = getMonthStep(addTime);

    const timeStep = currentTime - addTime;

    const H = Math.ceil(timeStep / (1000 * 60 * 60));
    const D = Math.floor(H / 24);

    if (yearStep > 0) {
        result = `${yearStep}年前`;
    } else if (monthStep > 0) {
        result = `${monthStep}月前`;
    } else if (D > 1) {
        result = `${D}天前`;
    } else {
        result = `${H}小时前`;
    }

    return result;
};

/**
 * @paramas time 时间的时间戳
 * return 年-月-日
 **/
const timeHandler = time => {
    if (!time) return '';
    const reg = /\//g;
    const charTime = time.replace(reg, '-');
    // const splitTime = charTime.split(' ');

    // return splitTime[0];
    return charTime;
};

/**
 * @paramas time 秒
 * return HH-MM-SS 时分秒
 **/
const timeChange = time => {
    const H = time % (60 * 60);
    const M = parseInt(time / 60);
    const S = time % 60;

    return `${addZero(M)}:${addZero(S)}`;
};

const formatTimeBySecdStr = secdStr => {
    secdStr = +secdStr;
    if (typeof secdStr !== 'number') return console.error('传入的不是数字类型');
    if (secdStr < 0) return console.error('传入的数字为负值');

    const H = secdStr >= 3600 ? parseInt(secdStr / 3600) : 0;
    const M = parseInt(secdStr % 3600) ? parseInt((secdStr - H * 3600) / 60) : 0;
    const S = secdStr % 60;

    return H ? `${addZero(H)}:${addZero(M)}:${addZero(S)}` : `${addZero(M)}:${addZero(S)}`;
};

/**
 * return object element index of array
 */
const getArrIndex = (arr, obj) => {
    let index = null;
    const key = Object.keys(obj)[0];

    arr.every((value, i) => {
        if (value[key] === obj[key]) {
            index = i;

            return false;
        }

        return true;
    });

    return index;
};

/**
 * @param {int|srting} num
 * @return {object} 格式化阅读量
 */
const numTransform = num => {
    const numInt = parseInt(num);
    const numStr = numInt.toString();
    const numLen = numStr.length;

    if (!numInt) return {};
    if (numLen <= 4) {
        return {
            num: numInt,
            isW: '',
        };
    } else if (numLen <= 6) {
        const startNum = numStr.substring(0, numLen - 4);
        const endTNum = numStr.charAt(numLen - 3);
        const endFum = numStr.charAt(numLen - 4);

        if (endTNum >= 5) {
            return {
                num: `${startNum}.${parseInt(endFum) + 1}`,
                isW: '万',
            };
        } else if (endFum === '0') {
            return {
                num: startNum,
                isW: '万',
            };
        } else {
            return {
                num: `${startNum}.${endFum}`,
                isW: '万',
            };
        }
    } else if (numLen >= 7) {
        const startNum = numStr.substring(0, numLen - 4);
        const endNum = numStr.charAt(numLen - 4);

        if (endNum >= 5) {
            return {
                num: (parseInt(startNum) + 1).toString(),
                isW: '万',
            };
        } else {
            return {
                num: startNum,
                isW: '万',
            };
        }
    }
};

const isChinese = temp => {
    const reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/;

    if (reg.test(temp)) {
        return true;
    }

    return false;
};

const formatTenThousand = num => {
    if (isNaN(num)) {
        return 0;
    }

    if (!isFinite(num) || num >= 100000000) {
        return '9999w+';
    }

    return num >= 10000 ? `${Math.round((num / 10000) * 100) / 100}w` : num;
};

export {
    isNullObject,
    formatTime,
    formatTimeObj,
    getAgeStep,
    dayBefore,
    timeHandler,
    timeChange,
    formatTimeBySecdStr,
    getArrIndex,
    numTransform,
    isChinese,
    formatTenThousand,
};
